import script from "./honorsAwards.vue?vue&type=script&setup=true&lang=js"
export * from "./honorsAwards.vue?vue&type=script&setup=true&lang=js"

import "./honorsAwards.vue?vue&type=style&index=0&id=2f17b1c1&scoped=true&lang=less"

import exportComponent from "/workspace/office-website/company-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f17b1c1"]])

export default __exports__